import Rest from '../Rest'

export default class UserService extends Rest {

  /**
   * @type {String}
   */
  static resource = '/api/v1/users'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  internalStore(data) {
    return this.post('/internal_store', data).then(data => {
      return data
    })
  }

  permissions() {
    return this.get('/permissions').then(data => {
      return data
    })
  }

  getUsers() {
    return this.get('/get/users').then(data => {
      return data
    })
  }

  changeRole(type: String) {
    return this.post(`/change_role`, {type: type}).then(data => {
      return data
    })
  }

  sendTextMessageNotification(userId, message = '') {
    return this.post(`${userId}/send_text_notification`, {message: message}).then(data => {
      return data
    })
  }

  findUserByEmail(email) {
    return this.get(`/find_by_email/${email}`).then((data) => {
      return data
    })
  }

  getLastAccess() {
    return this.get('/last-access').then((data) => {
      return data
    })
  }
}
